// src/components/Header/Header.tsx

import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.scss";
import logo from "../../assets/White watermark.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { FaSignInAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faFileAlt,
  faCalendar,
  faBook,
} from "@fortawesome/free-solid-svg-icons";

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      {/* 左侧：汉堡菜单 */}
      <div className={styles.left}>
        <div
          className={styles.hamburgerMenu}
          onClick={toggleMenu}
          role="button"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === "Enter") toggleMenu();
          }}
        >
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
        </div>
      </div>

      {/* 中间：Logo */}
      <div className={styles.center}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logo} />
        </Link>
      </div>

      {/* 侧边抽屉菜单 */}
      <div className={`${styles.sideDrawer} ${menuOpen ? styles.open : ""}`}>
        <nav className={styles.nav}>
          <ul className={styles.navList}>
            <li>
              <Link to="/" onClick={closeMenu}>
                <FontAwesomeIcon icon={faHome} className={styles.icon} />
                {t("nav.home")}
              </Link>
            </li>
            <li>
              <Link to="/quote/basic" onClick={closeMenu}>
                <FontAwesomeIcon icon={faFileAlt} className={styles.icon} />
                {t("nav.taxQuote")}
              </Link>
            </li>
            <li>
              <Link to="/appointment" onClick={closeMenu}>
                <FontAwesomeIcon icon={faCalendar} className={styles.icon} />
                {t("nav.appointment")}
              </Link>
            </li>
            <li className={styles.hasSubmenu}>
              <div className={styles.menuItem}>
                <FontAwesomeIcon icon={faBook} className={styles.icon} />
                {t("nav.docs")}
              </div>
              <ul className={styles.submenu}>
                <li className={styles.submenuLabel}>{t("docs.steps")}</li>
                <li>
                  <Link to="/docs/step0" onClick={closeMenu}>
                    Step 0 - {t("docs.filingProcess")}
                  </Link>
                </li>
                <li>
                  <Link to="/docs/step1" onClick={closeMenu}>
                    Step 1 - {t("docs.engagementLetter")}
                  </Link>
                </li>
                <li>
                  <Link to="/docs/step2" onClick={closeMenu}>
                    Step 2 - {t("docs.priceSchedule")}
                  </Link>
                </li>
                <li>
                  <Link to="/docs/step3" onClick={closeMenu}>
                    Step 3 - {t("docs.residencyQuestionnaire")}
                  </Link>
                </li>
                <li>
                  <Link to="/docs/step4" onClick={closeMenu}>
                    Step 4 - {t("docs.checklist")}
                  </Link>
                </li>
                <li className={styles.submenuLabel}>{t("docs.notes")}</li>
                <li>
                  <Link to="/docs/note-foreign-assets" onClick={closeMenu}>
                    {t("docs.foreignAssets")}
                  </Link>
                </li>
                <li>
                  <Link to="/docs/q-and-a" onClick={closeMenu}>
                    {t("docs.qAndA")}
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li>
              <Link to="/about" onClick={closeMenu}>
                <FaInfoCircle className={styles.icon} />
                {t("nav.aboutUs")}
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeMenu}>
                <FaEnvelope className={styles.icon} />
                {t("nav.contactUs")}
              </Link>
            </li> */}
          </ul>
        </nav>

        {/* 菜单底部按钮 */}
        <div className={styles.menuFooter}>
          <div className={styles.languageSwitcher}>
            <LanguageSwitcher />
          </div>
          <Link to="/login" className={styles.loginButton} onClick={closeMenu}>
            <FaSignInAlt className={styles.loginIcon} />
            {t("nav.login")}
          </Link>
        </div>
      </div>

      {/* 背景遮罩 */}
      {menuOpen && <div className={styles.backdrop} onClick={closeMenu}></div>}
    </header>
  );
};

export default Header;
